import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '../../components/Pleri/components/Settings/SettingsLayout';
import { NotificationSettings } from '../../components/Pleri/components/Settings/NotificationSettings';

export const Route = createFileRoute('/settings/notification')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SettingsLayout>
      <NotificationSettings />
    </SettingsLayout>
  );
}
